module.exports = __webpack_public_path__ + "static/media/5_3.aa6f7968.png";